module.exports = __webpack_public_path__ + "img/favicon.0553d2d8.png";